module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av206-c49db8af1f7f47b1a892fea8a8d822b2.jpg";